import type { ReactNode } from 'react'

/**
 * Boş durum. Liste ekranlarında zorunlu: boş bir tablo, kullanıcıya
 * "veri yok mu, filtre mi yanlış, yoksa hata mı?" sorusunu sordurur.
 */
export function EmptyState({
  title,
  description,
  action,
  icon,
}: {
  title: ReactNode
  description?: ReactNode
  action?: ReactNode
  icon?: ReactNode
}) {
  return (
    <div className="flex flex-col items-center gap-2 px-6 py-14 text-center">
      {icon && <div className="text-[var(--ad-text-muted)]">{icon}</div>}
      <p className="text-sm font-medium">{title}</p>
      {description && <p className="max-w-sm text-xs text-[var(--ad-text-muted)]">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  )
}
